import { CustomBoxV2 } from "components";
import { TotalSwingIcon } from "pages/internal-dashboard/icons";

export function TotalSwings({ data, loading, percentages, title, icon }: any) {
  return (
    <CustomBoxV2
      color="#78BA2C"
      loading={loading}
      title="Total Swings Captured Per User"
      userCount={data?.total || 0}
      boxData={{
        label: title,

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: icon,
      }}
      percentages={percentages}
    />
  );
}
